import { render } from "./WeightIcon.vue?vue&type=template&id=5b17b2ce"
import script from "./WeightIcon.vue?vue&type=script&lang=js"
export * from "./WeightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__